"use client";
import { CompositeContextProvider, CompositeScopedContextProvider } from "../composite/composite-context.js";
import { HovercardContextProvider, HovercardScopedContextProvider } from "../hovercard/hovercard-context.js";
import { MenubarContextProvider, MenubarScopedContextProvider, useMenubarContext, useMenubarProviderContext, useMenubarScopedContext } from "../menubar/menubar-context.js";
import { createStoreContext } from "@ariakit/react-utils";
import { createContext } from "react";
//#region src/menu/menu-context.tsx
const menu = createStoreContext([CompositeContextProvider, HovercardContextProvider], [CompositeScopedContextProvider, HovercardScopedContextProvider]);
/**
* Returns the menu store from the nearest menu container.
* @example
* function Menu() {
*   const store = useMenuContext();
*
*   if (!store) {
*     throw new Error("Menu must be wrapped in MenuProvider");
*   }
*
*   // Use the store...
* }
*/
const useMenuContext = menu.useContext;
const useMenuScopedContext = menu.useScopedContext;
const useMenuProviderContext = menu.useProviderContext;
const MenuContextProvider = menu.ContextProvider;
const MenuScopedContextProvider = menu.ScopedContextProvider;
/**
* Returns the menuBar store from the nearest menuBar container.
* @deprecated
* Use [`useMenubarContext`](https://ariakit.com/reference/use-menubar-context)
* instead.
* @example
* function MenuBar() {
*   const store = useMenuBarContext();
*
*   if (!store) {
*     throw new Error("MenuBar must be wrapped in MenuBarProvider");
*   }
*
*   // Use the store...
* }
*/
const useMenuBarContext = useMenubarContext;
const useMenuBarScopedContext = useMenubarScopedContext;
const useMenuBarProviderContext = useMenubarProviderContext;
const MenuBarContextProvider = MenubarContextProvider;
const MenuBarScopedContextProvider = MenubarScopedContextProvider;
const MenuItemCheckedContext = createContext(void 0);
/**
* Whether the enclosing menu list is currently hidden (e.g. a closed menu
* rendered without `unmountOnHide`). `MenuItem` uses it to skip registering
* items that aren't shown yet. Defaults to `false` so items without a menu list
* ancestor (such as menubar items) keep registering.
*/
const MenuListHiddenContext = createContext(false);
//#endregion
export { MenuBarContextProvider, MenuBarScopedContextProvider, MenuContextProvider, MenuItemCheckedContext, MenuListHiddenContext, MenuScopedContextProvider, useMenuBarContext, useMenuBarProviderContext, useMenuBarScopedContext, useMenuContext, useMenuProviderContext, useMenuScopedContext };

//# sourceMappingURL=menu-context.js.map